// This file was automatically generated and should not be edited.
/* eslint-disable */

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_seo_meditations_yoga_nidra: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `<strong>Yoga Nidra</strong><br>Literally translated as “yogic sleep,” yoga nidra helps you attune to the present as your inner knowing navigates you through the stages of deep relaxation. These guided meditations (which you’ll do lying down) are powerful, yet accessible.`,
    es: `<strong>Yoga Nidra</strong><br>Literalmente traducido como "sueño yóguico", el yoga nidra te ayuda a sintonizar con el presente mientras tu conocimiento interno te guía a través de las etapas de relajación profunda. Estas meditaciones guiadas (que harás recostado) son poderosas, pero accesibles.`,
  };
  return phrases[locale] || phrases.en || 'seo_meditations_yoga_nidra';
};
